import EmptyPage from '../../empty-page/emptyPage';

const OrgGuidAnalytics = () => {
    return <EmptyPage />;
};

export default OrgGuidAnalytics;
